<template>
  <div class="system-whatsapp-templates">
    <div class="header">
      <h2>הגדרות הודעות וואטסאפ ברירת מחדל</h2>
      <p class="description">
        אם לא הוזן מידע אחר, יש להציג לאדמין את הערכים הדיפולטיביים
      </p>
    </div>

    <div class="templates-container">
      <!-- נוסח 1 - הודעת בדיקת התעניינות -->
      <div class="template-section">
        <h3>נוסח מס' 1 - הודעת בדיקת התעניינות</h3>
        <div class="template-input">
          <textarea
            v-model="templates.whatsapp_template_interest_default"
            :placeholder="getDefaultInterestTemplate()"
            rows="4"
            class="form-control"
          ></textarea>
          <div class="default-display" v-if="!templates.whatsapp_template_interest_default">
            <h4>ערך ברירת מחדל:</h4>
            <div class="default-content">{{ getDefaultInterestTemplate() }}</div>
          </div>
          <div class="placeholders-info">
            <small>
              <strong>משתנים זמינים:</strong>
              [שם המועמד], [שם פרטי], [שם האופרציה], [שם המשרה]
            </small>
          </div>
        </div>
      </div>

      <!-- נוסח 3 - הודעת סיום שיחה -->
      <div class="template-section">
        <h3>נוסח מס' 3 - הודעת סיום שיחה</h3>
        <div class="template-input">
          <textarea
            v-model="templates.whatsapp_template_conversation_end_default"
            :placeholder="getDefaultEndTemplate()"
            rows="6"
            class="form-control"
          ></textarea>
          <div class="default-display" v-if="!templates.whatsapp_template_conversation_end_default">
            <h4>ערכים ברירת מחדל לפי אופרציה:</h4>
            <div class="defaults-tabs">
              <button
                v-for="operation in operations"
                :key="operation.key"
                @click="selectedOperation = operation.key"
                class="tab-button"
                :class="{ active: selectedOperation === operation.key }"
              >
                {{ operation.name }}
              </button>
            </div>
            <div class="default-content">{{ getDefaultTemplateForOperation(selectedOperation) }}</div>
          </div>
          <div class="placeholders-info">
            <small>
              <strong>משתנים זמינים:</strong>
              [קישור לעמוד המשרות של אופרציה רלווונטית]
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- תצוגה מקדימה -->
    <div class="preview-section" v-if="showPreview">
      <h3>תצוגה מקדימה</h3>

      <div class="preview-template">
        <h4>נוסח 1 - הודעת בדיקת התעניינות:</h4>
        <div class="preview-content">
          {{ getPreviewText(templates.whatsapp_template_interest_default || getDefaultInterestTemplate(), 'interest') }}
        </div>
      </div>

      <div class="preview-template">
        <h4>נוסח 3 - הודעת סיום שיחה:</h4>
        <div class="preview-content">
          {{ getPreviewText(templates.whatsapp_template_conversation_end_default || getDefaultEndTemplate(), 'end') }}
        </div>
      </div>
    </div>

    <!-- כפתורי פעולה -->
    <div class="actions">
      <button
        @click="togglePreview"
        class="btn btn-secondary"
        :class="{ active: showPreview }"
      >
        {{ showPreview ? 'הסתר תצוגה מקדימה' : 'הצג תצוגה מקדימה' }}
      </button>

      <button
        @click="resetToDefaults"
        class="btn btn-warning"
      >
        איפוס לברירת מחדל
      </button>

      <button
        @click="saveTemplates"
        class="btn btn-primary"
        :disabled="saving"
      >
        {{ saving ? 'שומר...' : 'שמור הגדרות' }}
      </button>
    </div>

    <!-- הודעות -->
    <div v-if="message" class="alert" :class="messageType">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SystemWhatsappTemplates',
  data () {
    return {
      templates: {
        whatsapp_template_interest_default: '',
        whatsapp_template_conversation_end_default: ''
      },
      originalTemplates: {},
      showPreview: false,
      saving: false,
      loading: true,
      message: '',
      messageType: '',
      selectedOperation: 'suitup',
      operations: [
        { key: 'suitup', name: 'SuitUp' },
        { key: 'rebase', name: 'Rebase' },
        { key: 'piola', name: 'Piola' }
      ]
    }
  },
  async mounted () {
    await this.loadTemplates()
    this.setDefaultOperationFromSettings()
  },
  methods: {
    async loadTemplates () {
      try {
        this.loading = true
        const response = await axios.get('/admin/v1/system_settings', {
          headers: {
            'Accept': 'admin api; version=1'
          }
        })

        this.templates = { ...response.data.data }
        this.originalTemplates = { ...response.data.data }
      } catch (error) {
        console.error('Error loading templates:', error)
        this.showMessage('שגיאה בטעינת ההגדרות', 'alert-danger')
      } finally {
        this.loading = false
      }
    },

    setDefaultOperationFromSettings () {
      // Try to determine the current operation from settings
      if (this.$settings && this.$settings.get) {
        const appName = this.$settings.get({ path: 'DISPLAY_APP_NAME' })
        if (appName && typeof appName.toLowerCase === 'function') {
          const operationName = appName.toLowerCase()
          if (this.operations.find(op => op.key === operationName)) {
            this.selectedOperation = operationName
          }
        }
      }
    },

    async saveTemplates () {
      try {
        this.saving = true

        await axios.put('/admin/v1/system_settings', {
          settings: this.templates
        }, {
          headers: {
            'Accept': 'admin api; version=1'
          }
        })

        this.originalTemplates = { ...this.templates }
        this.showMessage('ההגדרות נשמרו בהצלחה!', 'alert-success')
      } catch (error) {
        console.error('Error saving templates:', error)
        this.showMessage('שגיאה בשמירת ההגדרות', 'alert-danger')
      } finally {
        this.saving = false
      }
    },

    resetToDefaults () {
      if (confirm('האם אתה בטוח שברצונך לאפס את ההגדרות לברירת המחדל?')) {
        this.templates = {
          whatsapp_template_interest_default: this.getDefaultInterestTemplate(),
          whatsapp_template_conversation_end_default: this.getDefaultEndTemplate()
        }
      }
    },

    getDefaultInterestTemplate () {
      return 'היי [שם המועמד], מה שלומך?\nזו [שם פרטי] מ-[שם האופרציה]. ורציתי לבדוק האם משרה של [שם המשרה] יכולה לעניין אותך?'
    },

    getDefaultEndTemplate () {
      // Get the operation name from settings or determine it dynamically
      let operationName = this.selectedOperation || 'suitup'
      if (this.$settings && this.$settings.get) {
        const appName = this.$settings.get({ path: 'DISPLAY_APP_NAME' })
        if (appName && typeof appName.toLowerCase === 'function') {
          operationName = appName.toLowerCase()
        }
      }
      return this.getDefaultTemplateForOperation(operationName)
    },

    getDefaultTemplateForOperation (operationName) {
      switch (operationName) {
        case 'suitup':
          return `תודה על העדכון. בכל מקרה, אם יש לך חבר/ה שיתעניין לדעתך במשרה נשמח לסייע
ותמיד אפשר לצפות ולהגיש מועמדות למשרות באתר שלנו [קישור לעמוד המשרות של אופרציה רלווונטית]
וכדאי לעקוב אחרינו:
  בפייסבוק👍  https://www.facebook.com/suitup.co.il
  בלינקדאין👍  https://www.linkedin.com/company/suitup-io
ובאינסטגרם👍  https://www.instagram.com/suitup.co.il`

        case 'rebase':
          return `תודה רבה על העדכון.
בכל מקרה, תמיד אפשר לצפות ולהגיש מועמדות למשרות באתר שלנו. אני מצרפת עבורך קישורים למערכת Rebase שם המשרות שלנו מתעדכנות כל הזמן👷🏼
כדאי לעדכן את הפרטים שלך ולהגיש מועמדות למשרות נוספות הרלוונטיות עבורך
 https://web.rebase.co.il   
⚡יש לך חברים שמחפשים עבודה בתחום? אנחנו נשמח לסייע גם להם (כדאי שיציינו שהגיעו דרכך לטובת מבצע חבר מביא חבר שלנו 😏)
המשך יום נעים, Rebase :)`

        case 'piola':
          return `תודה על העדכון. בכל מקרה, אם יש לך חבר/ה שיתעניין לדעתך במשרה נשמח לסייע
ותמיד אפשר לצפות ולהגיש מועמדות למשרות באתר שלנו [קישור לעמוד המשרות של אופרציה רלווונטית]
וכדאי לעקוב אחרינו:
  בפייסבוק👍  https://www.facebook.com/PiolaHR
  בלינקדאין👍  https://www.linkedin.com/company/78366537/
ובאינסטגרם👍  https://www.instagram.com/piola_hr`

        default:
          return 'תודה על העדכון. בכל מקרה, אם יש לך חבר/ה שיתעניין לדעתך במשרה נשמח לסייע.'
      }
    },

    getOperationName (key) {
      const operation = this.operations.find(op => op.key === key)
      return operation ? operation.name : key
    },

    togglePreview () {
      this.showPreview = !this.showPreview
    },

    getPreviewText (template, type) {
      if (!template) return 'לא הוגדר נוסח'

      let preview = template

      if (type === 'interest') {
        preview = preview
          .replace(/\[שם המועמד\]/g, 'יוסי כהן')
          .replace(/\[שם פרטי\]/g, 'רחל')
          .replace(/\[שם האופרציה\]/g, 'Rebase')
          .replace(/\[שם המשרה\]/g, 'מפתח Full Stack')
      } else if (type === 'end') {
        preview = preview
          .replace(/\[קישור לעמוד המשרות של אופרציה רלווונטית\]/g, 'https://web.rebase.co.il')
      }

      return preview
    },

    showMessage (text, type) {
      this.message = text
      this.messageType = type
      setTimeout(() => {
        this.message = ''
        this.messageType = ''
      }, 5000)
    }
  }
}
</script>

<style scoped>
.system-whatsapp-templates {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.header {
  margin-bottom: 30px;
  text-align: center;
}

.header h2 {
  color: #333;
  margin-bottom: 10px;
}

.description {
  color: #666;
  font-size: 14px;
  font-weight: bold;
}

.templates-container {
  margin-bottom: 30px;
}

.template-section {
  margin-bottom: 25px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.template-section h3 {
  margin-bottom: 15px;
  color: #333;
  font-size: 16px;
}

.template-input textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: inherit;
  resize: vertical;
}

.default-display {
  margin: 15px 0;
  padding: 15px;
  background-color: #e8f4fd;
  border: 1px solid #b3d9f2;
  border-radius: 4px;
}

.default-display h4 {
  margin-bottom: 10px;
  color: #0056b3;
  font-size: 14px;
}

.defaults-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.tab-button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
}

.tab-button:hover {
  background-color: #f8f9fa;
}

.tab-button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.default-content {
  padding: 10px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.4;
  direction: rtl;
  text-align: right;
}

.placeholders-info {
  margin-top: 8px;
  color: #666;
}

.preview-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f0f8ff;
  border-radius: 8px;
  border: 1px solid #b0d4f1;
}

.preview-section h3 {
  margin-bottom: 20px;
  color: #333;
}

.preview-template {
  margin-bottom: 20px;
}

.preview-template h4 {
  margin-bottom: 10px;
  color: #555;
  font-size: 14px;
}

.preview-content {
  padding: 15px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.4;
}

.actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-primary:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

.btn-secondary.active {
  background-color: #28a745;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-warning:hover {
  background-color: #e0a800;
}

.alert {
  padding: 15px;
  border-radius: 4px;
  margin-top: 20px;
  text-align: center;
}

.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}
</style>
